import domain from '@/util/domain'
import store from "../store"
const gtagIdSGA = 'G-SGHE1CDZQZ';

// GOOGLE ANALYTICS 'TAGS CUSTOMERS'
const gtagIds = {
  '90sports': 'UA-210909534-1',
  'bettoro': 'UA-199153624-2',
  'ddbets': 'AW-639899329',
  'tikbet': 'G-1N1R43D08F',
  'betdasorte': 'G-JS4CZBZKRE',
}

// GTM - GOOGLE
const tagGTM = {
  'cartola': 'GTM-K88HK5S',
}
// INCLUIR TAG CADASTRADA NO BANCO
var gtmOperator = store.state.operators.google_tag_manager
if (tagGTM[domain()] == undefined && gtmOperator) {
  tagGTM[domain()] = gtmOperator
}

// FACEBOOK 'PIXEL CUSTOMERS'
const pixelIds = {
  'superbetsapp': ['254887366698560'],
  'ddbets': ['1130633337562621', '641370217456484'],
};

// KWAI 'PIXEL CUSTOMERS'
const pixelKwaiqs = {
  'dasorte': ['485002796619280414'],
};

// FACEBOOK 'Domain Verification CUSTOMERS'
const facebookDomainVerification = {
  'superbetsapp': '4o9vjn0hllmtjt9fx2n3dfcsikpatz',
  'apostamaster': '278w5gqlxyabwo20wjdp3okupohvhk',
};

// GOOGLE DOMAIN VERIFICATION
const googleVerification = {
  'superbetsapp': '0e7rFI0W2tQdaPnQEHnwCtCc_ogLfL1cU_af5IPMiL0',
}

// RD STATION MARKETING
const rdstation = {
  'betgol': "https://d335luupugsy2.cloudfront.net/js/loader-scripts/35f51446-1ecc-48ee-a8b0-580520f462e8-loader.js",
}

// SportRadar ADS
// const sportradar = {
//   'dasorte': "STM-AAAAUS",
// };

// const mgid = {
//   "dasorte": "773557",
// };

const chatTypeBot = {
  "pingolbet": `
    import Typebot from 'https://cdn.jsdelivr.net/npm/@typebot.io/js@0.2.31/dist/web.js'

    Typebot.initBubble({
      typebot: "pingolbet-suporte-9mplzke",
      apiHost: "https://bot.atendimentopingol.online",
      theme: {
        placement: "left",
        button: { backgroundColor: "#00d600" },
        chatWindow: { backgroundColor: "#171923" },
      },
    });
  `,
};


const customScript = {
  "pingolbet": `
    (function() {
    var s = document.createElement("script");
    s.async = true;
    s.src = (document.location.protocol === "https:" ? "https:" : "http:") + "//tags.fulllab.com.br/scripts/produto_pingolbet.js";
    var a = document.getElementsByTagName("script")[0];
    a.parentNode.insertBefore(s, a);
    })();
  `,
};

const injectAnalytics = () => {

  // INJECT GTM - GOOGLE
  let gtmTag = tagGTM[domain()];
  if (gtmTag) {
    injectGTM(gtmTag);
  }

  // INJECT GOOGLE ANALYTICS
  injectgTag();

  // INJECT PIXEL 'FACEBOOK'
  let pixelArr = pixelIds[domain()];
  if (pixelArr) {
    injectPixel(pixelArr);
  }

  // INJECT PIXEL 'KWAI'
  let pixelKwaiq = pixelKwaiqs[domain()];
  if (pixelKwaiq) {
    injectPixelKwai(pixelKwaiq);
  }

  // INJECT FACEBOOK DOMAIN VERIFICATION
  let codeVerification = facebookDomainVerification[domain()];
  if (codeVerification) {
    injectFacebookDomainVerification(codeVerification);
  }

  // INJECT GOOGLE VERIFICATION
  let codeVerificationG = googleVerification[domain()];
  if (codeVerificationG) {
    injectGoogleDomainVerification(codeVerificationG);
  }

  // INJECT RD STATION
  let codeRdStationSrc = rdstation[domain()];
  if (codeRdStationSrc) {
    injectRdStation(codeRdStationSrc);
  }

  // INJECT SPORTRADAR ADS
  // let codeSportRadar = sportradar[domain()];
  // if (codeSportRadar) {
  //   injectSportRadar(codeSportRadar);
  // }


  // if (mgid[domain()]) {
  //   injectMgSensor(mgid[domain()]);
  // }

  if (chatTypeBot[domain()]) {
    injectScript(chatTypeBot[domain()], "module");
  }

  if (customScript[domain()]) {
    injectScript(customScript[domain()], "application/javascript");
  }

  return;
}

// SOURCE INJECT GOOGLE ANALYTICS G-TAG
const injectgTag = () => {

  let analytics = '';
  let gtagCustomerId = gtagIds[domain()];
  if (gtagCustomerId != undefined) {
    analytics = `
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', '${gtagIdSGA}');
      gtag('config', '${gtagCustomerId}');
    `;
  } else {
    analytics = `
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', '${gtagIdSGA}');
    `;
  }

  var scriptAsync = document.createElement("script");
  scriptAsync.src = `https://www.googletagmanager.com/gtag/js?id=${gtagIdSGA}`;
  scriptAsync.async = true;
  document.head.appendChild(scriptAsync);

  var script = document.createElement("script");
  script.innerHTML = analytics;
  // Colocando como o Primeiro Elemento da Tag Head
  var head = document.getElementsByTagName("head")[0];
  head.insertBefore(script, head.childNodes[0]);
}

// SOURCE INJECT GTM
const injectGTM = (gtmTag) => {
  const gtmScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmTag}');`;
  // <script></script>
  var script = document.createElement("script");
  script.innerHTML = gtmScript;
  // Colocando como o Primeiro Elemento da Tag Head
  var head = document.getElementsByTagName("head")[0];
  head.insertBefore(script, head.childNodes[0]);


  // <noscript></noscript>
  var noscript = document.createElement("noscript");
  var iframe = document.createElement("iframe");
  iframe.height = "0";
  iframe.width = "0";
  iframe.style = "display:none;visibility:hidden";
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmTag}`;
  noscript.appendChild(iframe);
  // Colocando como o Primeiro Elemento da Tag Body
  var body = document.getElementsByTagName("body")[0];
  body.insertBefore(noscript, body.childNodes[0]);
}

// SOURCE INJECT PIXEL FACEBOOK
const injectPixel = (pixelArr) => {
  var pixel;
  if (pixelArr.length > 1) {
    pixel = `!function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
          n.callMethod ?
          n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
      }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelArr[0]}');
      fbq('init', '${pixelArr[1]}');
      fbq('track', 'PageView');`;
  } else {
    pixel = `!function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
          n.callMethod ?
          n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
      }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelArr[0]}');      
      fbq('track', 'PageView');`;
  }


  // <script></script>
  var script = document.createElement("script");
  script.innerHTML = pixel;
  document.head.appendChild(script);
  // <noscript></noscript>
  var noscript = document.createElement("noscript");
  var img = document.createElement("img");
  img.height = "1";
  img.width = "1";
  img.style = "display:none";
  img.src = `https://www.facebook.com/tr?id=${pixelArr[0]}&ev=PageView&noscript=1`;
  noscript.appendChild(img);
  document.head.appendChild(noscript);
}

// SOURCE INJECT SPORT RADAR ADS
const injectPixelKwai = (kwaiq) => {
  const dasortescriptkwai = `!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.install=t():e.install=t()}(window,(function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"_esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){"use strict";var r=this&&this._spreadArray||function(e,t,n){if(n||2===arguments.length)for(var r,o=0,i=t.length;o<i;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))};!function(e){var t=window;t.KwaiAnalyticsObject=e,t[e]=t[e]||[];var n=t[e];n.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];var o=function(e,t){e[t]=function(){var n=Array.from(arguments),o=r([t],n,!0);e.push(o)}};n.methods.forEach((function(e){o(n,e)})),n.instance=function(e){var t=n._i[e]||[];return n.methods.forEach((function(e){o(t,e)})),t},n.load=function(t,r){n._i=n._i||{},n._i[t]=[],n._i[t]._u="https://s1.kwai.net/kos/s101/nlav11187/pixel/events.js",n._t=n._t||{},n._t[t]=+new Date,n._o=n._o||{},n._o[t]=r||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src="https://s1.kwai.net/kos/s101/nlav11187/pixel/events.js?sdkid="+t+"&lib="+e;var i=document.getElementsByTagName("script")[0];i.parentNode.insertBefore(o,i)}}("kwaiq")}])}));`;

  // User Id no Kwai
  const dasortekwaiq = `
    kwaiq.load('${kwaiq}');
    kwaiq.page();
  `

  var script = document.createElement("script");
  script.innerHTML = dasortescriptkwai;
  var head = document.getElementsByTagName("head")[0];
  head.insertBefore(script, head.childNodes[0]);

  var scriptLoadKwaiq = document.createElement("script");
  scriptLoadKwaiq.innerHTML = dasortekwaiq;
  var headLoadKwaiq = document.getElementsByTagName("head")[0];
  headLoadKwaiq.insertBefore(scriptLoadKwaiq, headLoadKwaiq.childNodes[0]);
};

// SOURCE INJECT FACEBOOK DOMAIN VERIFICATION
const injectFacebookDomainVerification = (codeVerification) => {
  var meta = document.createElement("meta");
  meta.name = "facebook-domain-verification";
  meta.content = codeVerification;
  document.head.appendChild(meta);
}

// SOURCE INJECT GOOGLE DOMAIN VERIFICATION
const injectGoogleDomainVerification = (codeVerification) => {
  var meta = document.createElement("meta");
  meta.name = "google-site-verification";
  meta.content = codeVerification;
  document.head.appendChild(meta);
}

// SOURCE INJECT RD STATION MKT
const injectRdStation = (rdSrc) => {
  var script = document.createElement("script");
  script.async = true;
  script.type = "text/javascript"
  script.src = rdSrc;
  document.body.appendChild(script);
}

// SOURCE INJECT SPORT RADAR ADS
// const injectSportRadar = (code) => {
//   const sportRadrScript = `(function(a,b,c,d,e,f){a[e]=a[e]||[];a.x=b.createElement(c);a.y=b.getElementsByTagName(c)[0];x.src=d+"?id="+f;x.setAttribute("data-srtmn",e);y.parentNode.insertBefore(x,y);}(window,document,"script","https://tm.ads.sportradar.com/dist/tag-manager.js","srtmCommands","${code}"));`;
//   var script = document.createElement("script");
//   script.innerHTML = sportRadrScript;
//   var head = document.getElementsByTagName("head")[0];
//   head.insertBefore(script, head.childNodes[0]);
// };

// // SOURCE INJECT MG SENSOR
// const injectMgSensor = (cid) => {
//   const script = document.createElement("script");

//   script.innerHTML = `
//     (function() {
//       var d = document, w = window;
//       w.MgSensorData = w.MgSensorData || [];
//       w.MgSensorData.push({
//           cid: ${cid},
//           lng:"us",
//           project: "a.mgid.com"
//       });
//       var l = "a.mgid.com";
//       var n = d.getElementsByTagName("script")[0];
//       var s = d.createElement("script");
//       s.type = "text/javascript";
//       s.async = true;
//       var dt = !Date.now?new Date().valueOf():Date.now();
//       s.src = "https://" + l + "/mgsensor.js?d=" + dt;
//       n.parentNode.insertBefore(s, n);
//     })();
//   `;

//   const head = document.getElementsByTagName("head")[0];
//   head.insertBefore(script, head.childNodes[0]);
// };

// SOURCE INJECT CHAT TYPEBOT
const injectScript = (script, type) => {
  // Script typebot anteriomente configurados
  var initializeScript = document.createElement("script");
  initializeScript.type = type;
  initializeScript.innerHTML = script;

  const head = document.getElementsByTagName("head")[0];
  head.insertBefore(initializeScript, head.childNodes[0]);
};

export { injectAnalytics, injectGTM, injectgTag };